import React, { Component } from 'react';

class ImageViewer extends Component {
	render() {
		return (
			<div className="image-viewer">
				<div className="mask" onClick={this.props.onClose}>
					<div className="block" onClick={this.props.onClose}>
						<div className="close-btn" onClick={this.props.onClose}></div>
						<img src={this.props.url} alt="" />
					</div>
				</div>
			</div>
		);
	}
}

export default ImageViewer;



// WEBPACK FOOTER //
// ./src/ImageViewer.js